import { z } from "zod";
import { emailSchema, passwordSchema } from "./auth.js";

/** Panelden atanabilen roller (THE ADAM destek rolü hariç). */
export const ASSIGNABLE_ROLE_KEYS = ["owner", "operations", "warehouse", "catalog", "finance", "viewer"] as const;
export type AssignableRoleKey = (typeof ASSIGNABLE_ROLE_KEYS)[number];

export const createUserSchema = z.object({
  name: z.string().trim().min(2, "Ad soyad girin").max(160),
  email: emailSchema,
  roleKey: z.enum(ASSIGNABLE_ROLE_KEYS),
  password: passwordSchema,
});
export type CreateUserInput = z.infer<typeof createUserSchema>;

export const updateMemberSchema = z
  .object({
    roleKey: z.enum(ASSIGNABLE_ROLE_KEYS).optional(),
    status: z.enum(["active", "suspended"]).optional(),
  })
  .refine((v) => v.roleKey || v.status, "Değiştirilecek bir alan seçin");

export const setPasswordSchema = z.object({ password: passwordSchema });

/** E-postayla davet (7 gün geçerli bağlantı). */
export const inviteUserSchema = z.object({
  email: emailSchema,
  name: z.string().trim().max(160).optional(),
  roleKey: z.enum(ASSIGNABLE_ROLE_KEYS),
});
export type InviteUserInput = z.infer<typeof inviteUserSchema>;

/** Daveti kabul: yeni hesapta ad ve şifre; mevcut hesapta mevcut şifre. */
export const acceptInvitationSchema = z.object({
  name: z.string().trim().min(2, "Ad soyad girin").max(160).optional(),
  password: z.string().min(1, "Şifre girin").max(200),
});

export interface InvitationDto {
  id: string;
  email: string;
  role: { key: string; name: string };
  createdAt: string;
  expiresAt: string;
}

export interface InvitationInfoDto {
  tenantName: string;
  email: string;
  roleName: string;
  /** E-posta başka bir çalışma alanında zaten kayıtlıysa mevcut şifreyle katılır. */
  existingAccount: boolean;
}


export interface MemberDto {
  membershipId: string;
  userId: string;
  name: string;
  email: string;
  role: { key: string; name: string };
  status: "active" | "suspended";
  lastLoginAt: string | null;
  createdAt: string;
  isSelf: boolean;
  avatarUrl: string | null;
  twoFactorEnabled: boolean;
}

export interface UsersResponse {
  members: MemberDto[];
  invitations?: InvitationDto[];
  roles: { key: AssignableRoleKey; name: string; description: string | null }[];
}
